<template lang="pug">
v-row(v-if="contentpage")
	v-col(xs="12" md="8")
		h1 {{contentpage.name}}
		ws-content(:value="contentpage.content")
			template(slot="videos")
				v-row(v-for="video in resort.videos" :key="video.videoId")
					v-col
						vue-plyr(v-if="video.videoSource === 'youtube' || video.videoSource === 'vimeo'" :options='{"controls":["play", "progress", "volume", "play-large", "airplay", "fullscreen", "pip", "mute"], "disableContextMenu": false}' :key="video.videoId")
							div(:data-plyr-provider="video.videoSource" :data-plyr-embed-id="video.videoId")
						video-hls(v-else-if="video.videoSource === 'video'" :videoUrl="video.videoId")
</template>

<script>
import gql from 'graphql-tag';
import Content from '@dengl/common/components/content.vue';
import MetaFragment from '@/components/graphql/metaFragment.graphql';

const getResortVideos = gql`
	query getResortVideos($slug: String!, $path: String, $fallback: String) {
		contentpage(path: $path, fallback: $fallback) {
			id
			name
			slug
			content {
				...ContentDataFragment
			}
			...MetaFragment
		}
		resort(slug: $slug) {
			id
			name
			slug
			country {
				id
				name
				countryCode
				slug
			}
			region {
				id
				name
				slug
			}
			area {
				id
				name
				slug
			}
			videos {
				videoId
				videoSource
				description
			}
		}
	}
	${Content.fragments}
	${MetaFragment}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/dorpen/:resort/video',
			'de-DE': '/skiorte/:resort/videos',
			'nl-BE': '/dorpen/:resort/video'
		}
	},
	layout: 'default',
	// eslint-disable-next-line @milqmedia/milq/page-has-meta
	asyncData({ params, app, route }) {
		return app.$graphClient
			.query({
				query: getResortVideos,
				variables: {
					slug: params.resort,
					path: route.path,
					fallback: route.path.replace(params.resort, '_resort')
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'resort-video-01', errors);
				}
				if (errors) {
					throw errors[0];
				}

				app.interpolater(data.contentpage.meta, ['title', 'description']);
				app.interpolater(data.contentpage.content, ['markdown']);
				app.interpolater(data.contentpage, ['name']);

				app.meta(data.contentpage.meta);
				app.ads({
					sidebar: {
						visible: true,
						targets: {
							Village: data.resort.id,
							Skiresort: data.resort.area.id,
							State: data.resort.region.id,
							Country: data.resort.country.id
						}
					}
				});
				app.resortBreadcrumbs(data.resort, {
					[app.i18n.t(`page.resorts._resort.video:breadcrumb`)]: {
						name: 'resorts-resort-video',
						params: { resort: data.resort.slug }
					}
				});

				return data;
			})
			.catch(app.$destinationNotFoundCatcher)
			.catch(error => {
				return app.httpError(500, null, 'resorts-resort-video-02', error);
			});
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	created() {
		this.$emit('update:showSidebar', true);
	}
};
</script>
